import { RevisionRow } from 'components/tables/data/revision/types';
import RevisionActions from 'components/tables/data/revision/RevisionActions';
import { useRevisionTableContext } from 'components/tables/data/revision/RevisionTable';
import { useMemo } from 'react';

/**
 * Column for the actions.
 */
export default function ActionsColumn({ data }: { data: RevisionRow }) {
  const { onStatusChange, onNoLongerAccessible, viewVariant } = useRevisionTableContext();

  const key = useMemo(
    () => `actions-${data.revisionId}-${data.revisionStatus.revisionStatusId}`,
    [data.revisionId, data.revisionStatus.revisionStatusId]
  );

  return (
    <RevisionActions
      key={key}
      revision={data}
      viewOnly={viewVariant === 'view-by-device'}
      compactOnTablet
      onStatusChange={(params) => onStatusChange({ ...params, revisionId: data.revisionId })}
      onNoLongerAccessible={onNoLongerAccessible}
    />
  );
}
